var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 8.58002L12.6484 13.8925C13 14.2831 13 14.8691 12.6484 15.2206L11.75 16.1191C11.3984 16.4706 10.7734 16.4706 10.4219 16.1191L6.67188 12.33L2.88281 16.1191C2.53125 16.4706 1.94531 16.4706 1.55469 16.1191L0.695312 15.2206C0.304688 14.8691 0.304688 14.2831 0.695312 13.8925L6.00781 8.58002C6.35938 8.22845 6.94531 8.22845 7.33594 8.58002ZM6.00781 1.08002C6.35938 0.728455 6.94531 0.728455 7.29688 1.08002L12.6094 6.39252C13 6.74408 13 7.36908 12.6094 7.72064L11.75 8.61908C11.3594 8.97064 10.7734 8.97064 10.4219 8.61908L6.63281 4.83002L2.88281 8.61908C2.53125 8.97064 1.94531 8.97064 1.55469 8.61908L0.695312 7.72064C0.304688 7.36908 0.304688 6.78314 0.695312 6.39252L6.00781 1.08002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSymbol);
export default __webpack_public_path__ + "static/media/top-symbol.557cea44eeda9599545f7760df93bd1b.svg";
export { ForwardRef as ReactComponent };